import {
    FormattedMessageHeaderRenderer,
    FormattedMessageWithTooltipHeaderRenderer,
} from '../../../components/HeaderRenderers';
import { formattedNumberValueGetter, gridNumberFormatter } from '../../../components/ValueFormatters';
import { normalizeColumnDefs } from '../../../utils';
import { alwaysVisibleColumnType, leftPinnedColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { OS_FAMILY_VIDEO_REPORT_ID } from './osFamilyVideoReportId';

const osFamilyReportColumnDefinition = [
    {
        headerName: FIELDS.PLATFORM_CODE.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.PLATFORM_CODE.headerComponentParams,
        field: FIELDS.PLATFORM_CODE.field,
        type: [leftPinnedColumn, alwaysVisibleColumnType],
        cellRenderer: FIELDS.PLATFORM_CODE.cellRenderer,
        cellRendererParams: FIELDS.PLATFORM_CODE.renderParams,
        csvValueGetter: FIELDS.PLATFORM_CODE.csvValueGetter,
    },
    {
        headerName: FIELDS.OS_FAMILY.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.OS_FAMILY.headerComponentParams,
        field: FIELDS.OS_FAMILY.field,
        type: [leftPinnedColumn, alwaysVisibleColumnType],
        csvValueGetter: FIELDS.OS_FAMILY.csvValueGetter,
    },
    ...[
        FIELDS.SPENT,
        FIELDS.COMPLETED_VIEWS,
        FIELDS.VIDEO_IMPRESSIONS,
        FIELDS.VIDEO_VISIBLE_IMPRESSIONS,
        FIELDS.VIDEO_CPM,
        FIELDS.VIDEO_VCPM,
        FIELDS.CPCV,
        FIELDS.VIEWABILITY_RATE,
        FIELDS.HUNDRED_PCT_VIEWABILITY_RATE,
        FIELDS.COMPLETION_RATE,
        FIELDS.CLICKS,
        FIELDS.VIDEO_CTR,
        FIELDS.VIDEO_VCTR,
        FIELDS.CPA,
        FIELDS.VIDEO_CVR,
        FIELDS.CONVERSIONS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(osFamilyReportColumnDefinition, OS_FAMILY_VIDEO_REPORT_ID);
